// Expose the jQuery
import jQuery from 'jquery'
window.$ = window.jQuery = jQuery
